import { SoundscapeMiniPlayer } from '@/features/play-soundscape'
import { useFocusAutotrack } from '../model/use-focus-autotrack'

// Фокус живёт в шапке, а не только на своей странице: звук не рвётся переходом
// между досками, поэтому и сессия фокуса считается здесь — иначе heartbeat
// прекращался бы, стоило уйти с консоли, при играющем режиме.
export function FocusSlot() {
  useFocusAutotrack()
  return <SoundscapeMiniPlayer />
}
